import { logEvent } from 'firebase/analytics';
import { getAnalyticsInstance, initAnalytics } from '../firebase';
import { isAnalyticsAllowed } from './cookieConsent';

export const trackDemoEvent = (eventName, parameters = {}) => {
  // Don't track if user hasn't consented
  if (!isAnalyticsAllowed()) {
    console.log('📊 Analytics tracking skipped (no consent):', eventName);
    return;
  }

  try {
    // Try to get existing analytics instance or initialize if needed
    let analytics = getAnalyticsInstance();
    if (!analytics) {
      analytics = initAnalytics();
    }
    
    if (analytics) {
      logEvent(analytics, eventName, parameters);
      console.log('📊 Analytics event tracked:', eventName, parameters);
    }
  } catch (error) {
    console.error('Analytics error:', error);
  }
};

// Specific tracking functions
export const trackConfigurationChange = (demoType, settingName, newValue) => {
  trackDemoEvent('demo_configuration_change', {
    demo_type: demoType, // 'shipstation' or 'veeqo'
    setting_name: settingName, // 'mapTo', 'surfaceNames', etc.
    new_value: newValue
  });
};

export const trackTabChange = (demoType) => {
  trackDemoEvent('demo_tab_change', {
    demo_type: demoType // 'shipstation' or 'veeqo'
  });
};

export const trackViewChange = (demoType, viewType) => {
  trackDemoEvent('demo_view_change', {
    demo_type: demoType, // 'shipstation' or 'veeqo'
    view_type: viewType // 'order' or 'packing'
  });
};
